import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Widget from '../views/Widget.vue';
import External from '../views/External.vue';
import OrderSucceed from '../views/OrderSucceed.vue';

const routes = [
  {
    path: '/',
    name: 'HOME',
    component: Home,
  },
  {
    path: '/widget',
    name: 'WIDGET',
    component: Widget,
  },
  {
    path: '/external',
    name: 'PAYMENT',
    alias: '/payment',
    component: External,
  },
  {
    path: '/payment',
    name: 'PAYMENT',
    component: External,
  },
  {
    path: '/order-succeed',
    name: 'ORDER_SUCCEED',
    component: OrderSucceed,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
